export default __webpack_public_path__ + "static/media/added-to-cart.969db4aa.png";